import type { PortfolioFilter, PortfolioSite } from '../types'

export const portfolioFilters: PortfolioFilter[] = [
  { id: 'all', label: 'Todos' },
  { id: 'contractors', label: 'Contratistas' },
  { id: 'roofing', label: 'Techadores' },
  { id: 'business', label: 'Emprendedores' },
  { id: 'dental', label: 'Dentistas' },
  { id: 'restaurant', label: 'Restaurantes' },
  { id: 'landscaping', label: 'Landscaping' },
  { id: 'beauty', label: 'Belleza' },
]

export const portfolioSites: PortfolioSite[] = [
  {
    id: 'morales-contracting',
    name: 'Morales Contracting Group',
    niche: 'contractors',
    nicheLabel: 'Contratistas',
    description:
      'Contratista general bilingüe: pintura, decks, roofing y cotización en línea.',
    url: 'https://project-morales-contracting-services-984.magicpatterns.app/',
    live: true,
  },
  {
    id: 'morales-pro-services',
    name: 'Morales Pro Services',
    niche: 'contractors',
    nicheLabel: 'Contratistas',
    description:
      'Landing page de remodelación con cotización gratis y chat de WhatsApp.',
    url: 'https://project-morales-pro-services-landing-page-267.magicpatterns.app/',
    live: true,
  },
  {
    id: 'maria-jorge-negocio',
    name: 'María & Jorge · Amway',
    niche: 'business',
    nicheLabel: 'Emprendedores',
    description:
      'Landing de oportunidad de negocio con historia, plan y registro de equipo.',
    url: 'https://project-maria-and-jorge-business-opportunity-467.magicpatterns.app',
    live: true,
  },
  {
    id: 'los-tres-caminos',
    name: 'Los Tres Caminos',
    niche: 'restaurant',
    nicheLabel: 'Restaurantes',
    description:
      'Restaurante mexicano con menú, reservaciones y pedidos en línea.',
    url: 'https://project-los-tres-caminos-website-348.magicpatterns.app',
    live: true,
  },
  {
    id: 'castle-nail-spa',
    name: 'Castle Nail & Spa',
    niche: 'beauty',
    nicheLabel: 'Belleza',
    description:
      'Salón de uñas en Terre Haute con catálogo de diseños y citas en línea.',
    url: 'https://project-magnetic-cucumber-546.magicpatterns.app',
    live: true,
  },
  {
    id: 'ramirez-roofing',
    name: 'Ramírez Roofing Co.',
    niche: 'roofing',
    nicheLabel: 'Techadores',
    description: 'Web profesional con galería de proyectos y cotización online.',
    url: 'https://ramirezroofing.com',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/713682b2-b3fb-4d8d-bc66-4e7c660305fb.jpg',
  },
  {
    id: 'sonrisas-dental',
    name: 'Sonrisas Dental',
    niche: 'dental',
    nicheLabel: 'Dentistas',
    description: 'Clínica dental con agenda online y formulario de pacientes.',
    url: 'https://sonrisasdental.com',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f76cb4ff-107d-4816-8512-64cd7900543e.jpg',
  },
  {
    id: 'taqueria-el-rancho',
    name: 'Taquería El Rancho',
    niche: 'restaurant',
    nicheLabel: 'Restaurantes',
    description: 'Menú digital, horarios y reservaciones en línea.',
    url: 'https://taqueriaelrancho.com',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/83964de5-d3a8-4b6b-a4a2-e525ca4b06cc.jpg',
  },
  {
    id: 'verde-landscaping',
    name: 'Verde Landscaping',
    niche: 'landscaping',
    nicheLabel: 'Landscaping',
    description: 'Servicios de jardinería con galería de proyectos y contacto.',
    url: 'https://verdelandscaping.com',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/afb7b43c-6428-4313-90e3-de135419a2ee.jpg',
  },
  {
    id: 'glamour-beauty-spa',
    name: 'Glamour Beauty Spa',
    niche: 'beauty',
    nicheLabel: 'Belleza',
    description: 'Spa y salón con reservación de citas y catálogo de servicios.',
    url: 'https://glamourbeautyspa.com',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/242ba9d3-8db4-463b-9f83-b5a5abcbf55b.jpg',
  },
  {
    id: 'elite-contractors',
    name: 'Elite Contractors',
    niche: 'contractors',
    nicheLabel: 'Contratistas',
    description: 'Contratistas generales con portafolio de obras y cotizador.',
    url: 'https://elitecontractors.com',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2fafed71-7ead-4865-9803-c9cace593db1.jpg',
  },
]
